
import styled from 'styled-components'
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';


const Container=styled.div`
 width:100%;
 display:flex;
 justify-content:center;
 
 `;



export default function SteperBottom(props){
	const theme = useTheme();

	return(
		<Container>
				<MobileStepper variant="progress" steps={props.totalSteps} position="static" activeStep={props.step} sx={{ maxWidth: 900, flexGrow: 1 }}
 	    		nextButton={
 	       		<Button size="large" onClick={props.next} disabled={props.step === props.totalSteps-1}>
						Next
 	       			{theme.direction === 'rtl' ? ( <KeyboardArrowLeft /> ) : ( <KeyboardArrowRight />  )}
 	       		</Button>
 	     		}
	
 	     		backButton={
 	       		<Button size="large" onClick={props.preview} disabled={props.step === 0}>
 	         			{theme.direction === 'rtl' ? (<KeyboardArrowRight /> ) : (<KeyboardArrowLeft />)}
 	         			Back
 	       		</Button>
 	     		}
 	   		/>


		</Container>



		)
}